import "./MicroNirPatWx.module.css";
import Header from "@/reusable_sections/Header";
import MicroNIR from "./sections/MicroNIR";
import Applications from "./sections/Applications";
import RelatedSolutions from "./sections/RelatedSolutions";
import RelatedServices from "./sections/RelatedServices";
import DiscussCTA from "./sections/DiscussCTA";
import Footer from "@/reusable_sections/Footer";
export default function MicroNirPatWxPage() {
  return <div>
      <Header />
      <MicroNIR />
      <Applications />
      <RelatedSolutions />
      <RelatedServices />
      <DiscussCTA />
      <Footer />
    </div>;
}